import React from 'react';

export interface AppFooterLink {
  text: string;
  url: string;
}

export interface AppFooterProps {
  disclaimerText?: string;
  copyRight?: string;
  footerText?: string;
  footerText1?: string;
  footerLinkText1?: string;
  footerLinkURL1?: string;
  versionText?: string;
}

export const AppFooter = React.memo(function AppFooter({
  disclaimerText,
  copyRight = '©',
  footerText = '',
  footerText1,
  footerLinkText1,
  footerLinkURL1,
  versionText,
}: AppFooterProps) {
  const currentYear = new Date().getFullYear();
  const hasFooterLink = Boolean(footerLinkURL1 && footerLinkText1);
  const hasFooterText1 = Boolean(footerText1);

  return (
    <footer className='app-footer' role='contentinfo'>
      {disclaimerText && (
        <div className='app-footer__disclaimer'>
          {disclaimerText}
        </div>
      )}

      <div className='app-footer__content'>
        <span className='app-footer__meta'>
          {copyRight} {currentYear} {footerText}
          {hasFooterLink && (
            <>
              {' '}
              <a href={footerLinkURL1} target="_blank" rel="noopener noreferrer" className='app-footer__link'>
                {footerLinkText1}
              </a>
            </>
          )}
          {hasFooterText1 && <> {hasFooterLink ? '. ' : ' '}{footerText1}</>}
        </span>
        {versionText && (
          <span
            className='app-footer__version'
            title={`Application version: ${versionText}`}
          >
            v{versionText}
          </span>
        )}
      </div>
    </footer>
  );
});

export default AppFooter;